/** Values returned in `orderPageVo.nextActions` from POST /v1/order/order-page */
export const O2O_NEXT_ACTION = {
  CANCEL_ORDER: 'CANCEL_ORDER',
  AUDIT_ORDER: 'AUDIT_ORDER',
  CONFIRM_CUSTOMER_RECEIVE: 'CONFIRM_CUSTOMER_RECEIVE',
  CONFIRM_DELIVERY_FAILED: 'CONFIRM_DELIVERY_FAILED',
  RETRY_DELIVERY: 'RETRY_DELIVERY',
  RETURN_STOCK: 'RETURN_STOCK',
} as const;

export type O2oNextActionCode =
  (typeof O2O_NEXT_ACTION)[keyof typeof O2O_NEXT_ACTION];

function normalizeNextActionKey(value: string): string {
  return value.trim().toUpperCase().replace(/[^A-Z0-9]/g, '');
}

const ACTION_KEY_MAP: Record<string, O2oNextActionCode> = {
  [normalizeNextActionKey(O2O_NEXT_ACTION.CANCEL_ORDER)]:
    O2O_NEXT_ACTION.CANCEL_ORDER,
  [normalizeNextActionKey(O2O_NEXT_ACTION.AUDIT_ORDER)]:
    O2O_NEXT_ACTION.AUDIT_ORDER,
  [normalizeNextActionKey(O2O_NEXT_ACTION.CONFIRM_CUSTOMER_RECEIVE)]:
    O2O_NEXT_ACTION.CONFIRM_CUSTOMER_RECEIVE,
  [normalizeNextActionKey(O2O_NEXT_ACTION.CONFIRM_DELIVERY_FAILED)]:
    O2O_NEXT_ACTION.CONFIRM_DELIVERY_FAILED,
  [normalizeNextActionKey(O2O_NEXT_ACTION.RETRY_DELIVERY)]:
    O2O_NEXT_ACTION.RETRY_DELIVERY,
  [normalizeNextActionKey(O2O_NEXT_ACTION.RETURN_STOCK)]:
    O2O_NEXT_ACTION.RETURN_STOCK,
  // Backend OrderNextActionEnum uses display labels
  [normalizeNextActionKey('Confirm Customer Receive')]:
    O2O_NEXT_ACTION.CONFIRM_CUSTOMER_RECEIVE,
  [normalizeNextActionKey('Confirm Delivery Failed')]:
    O2O_NEXT_ACTION.CONFIRM_DELIVERY_FAILED,
  [normalizeNextActionKey('Retry Delivery')]: O2O_NEXT_ACTION.RETRY_DELIVERY,
  [normalizeNextActionKey('Return Stock')]: O2O_NEXT_ACTION.RETURN_STOCK,
};

export function parseO2oNextActions(
  nextActions?: string[],
): Set<O2oNextActionCode> {
  const set = new Set<O2oNextActionCode>();
  for (const raw of nextActions ?? []) {
    const code = ACTION_KEY_MAP[normalizeNextActionKey(raw)];
    if (code) {
      set.add(code);
    }
  }
  return set;
}

export function rowHasO2oNextAction(
  row: { nextActions?: string[] },
  action: O2oNextActionCode,
): boolean {
  return parseO2oNextActions(row.nextActions).has(action);
}

export function rowHasAnyO2oNextAction(row: {
  nextActions?: string[];
}): boolean {
  return parseO2oNextActions(row.nextActions).size > 0;
}
